// start:ng42.barrel
import './user-roles-editor-popup.component';
// end:ng42.barrel

